<template>
  <div class="product-bed">
    <!-- Main Image Start -->
    <div class="product__bg-image">
      <div class="bg-image"
           :style="{backgroundImage: `url(${require('../assets/img/img_banner_bed.png')})`}">
        <div class="bg-image__content">
          <!-- language check -->
          <template v-if="$i18n.locale() === 'ko'">
            <!-- ** lang KO Start ** -->
            <div class="bg-image__sub-title no-drag sub-title--ko"
                 data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="400">
              <span>{{$t('bed.sub-title')}}</span>
            </div>
            <div class="bg-image__title no-drag title--ko"
                 data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="300">
              <span v-html="$t('bed.title')">Smart Bed<br/>System</span>
            </div>
            <!-- ** lang KO End ** -->
          </template>
          <template v-else>
            <!-- ** lang EN Start ** -->
            <div class="bg-image__title no-drag"
                 data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="300">
              <span v-html="$t('bed.title')">Smart Bed<br/>System</span>
            </div>
            <div class="bg-image__sub-title no-drag"
                 data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="400">
              <span>{{$t('bed.sub-title')}}</span>
            </div>
            <!-- ** lang EN Start ** -->
          </template>
        </div>
      </div>
    </div>
    <!-- Main Image End -->

    <!-- Bed Info Start -->
    <bed-info/>
    <!-- Bed Info End -->

    <!-- Bed App Start -->
    <bed-app/>
    <!-- Bed App End -->

    <!-- Bed Web Start -->
    <bed-web/>
    <!-- Bed Web End -->
  </div>
</template>

<script>
import BedInfo from '../components/productBed/BedInfo.vue';
import BedApp from '../components/productBed/BedApp.vue';
import BedWeb from '../components/productBed/BedWeb.vue';
import { FadeUpMixin } from '../components/mixins/FadeUp';
import { setLanguageMixin } from '../components/mixins/setLanguage';

export default {
  name: 'ProductBed',
  components: {
    BedInfo,
    BedApp,
    BedWeb,
  },
  data() {
    return {
    };
  },
  mixins: [setLanguageMixin, FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import "../assets/scss/bgImage";

  .product-bed {
    flex-shrink: 0;
  }
</style>
